<template>
  <header class="navbar panel-shell">
    <div class="nav-left">
      <router-link :to="homePath" class="brand-link">
        <div class="brand-mark">Q</div>
        <div class="brand-copy">
          <div class="brand-title">Labsqure</div>
          <div class="brand-subtitle">企业认证管理后台</div>
        </div>
      </router-link>
    </div>

    <div class="nav-right">
      <el-menu
        class="top-nav-menu"
        mode="horizontal"
        :default-active="activeMenu"
        background-color="transparent"
        text-color="#46667a"
        active-text-color="#111827"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="item in directMenus"
          :key="item.index"
          :index="item.index"
        >
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </el-menu-item>

        <el-submenu
          v-if="basicMenus.length"
          index="/basic"
          popper-class="top-nav-popper"
        >
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>基本管理</span>
          </template>
          <el-menu-item
            v-for="item in basicMenus"
            :key="item.index"
            :index="item.index"
          >
            {{ item.label }}
          </el-menu-item>
        </el-submenu>
      </el-menu>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <div class="avatar-mark">{{ nameInitial }}</div>
          <div class="user-meta">
            <span class="user-name">{{ name }}</span>
            <span class="user-role">账户中心</span>
          </div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link :to="homePath">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BASIC_MENU_ITEMS,
  TOP_NAV_MENU_ITEMS,
  canAccessRequirement,
  resolveDefaultHomePath
} from '@/utils/permission'

export default {
  computed: {
    ...mapGetters([
      'name',
      'permissionCodes',
      'menuKeys',
      'isSuperAdmin',
      'defaultHome'
    ]),
    authState() {
      return {
        permissionCodes: this.permissionCodes,
        menuKeys: this.menuKeys,
        isSuperAdmin: this.isSuperAdmin
      }
    },
    homePath() {
      return resolveDefaultHomePath(this.authState, this.defaultHome)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta && meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    allMenus() {
      return TOP_NAV_MENU_ITEMS.filter(item => this.canAccess(item))
    },
    directMenus() {
      return this.allMenus
    },
    basicMenus() {
      return BASIC_MENU_ITEMS.filter(item => this.canAccess(item))
    },
    nameInitial() {
      return (this.name || 'A').slice(0, 1).toUpperCase()
    }
  },
  methods: {
    canAccess(requirement) {
      return canAccessRequirement(requirement, this.authState)
    },
    handleSelect(index) {
      if (index && index !== this.$route.path) {
        this.$router.push(index)
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style scoped>
.navbar {
  min-height: 72px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.nav-left {
  flex-shrink: 0;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand-mark {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #1f87be;
  border: 1px solid #bfd9e6;
  font-size: 15px;
  font-weight: 700;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-title {
  color: #111827;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}

.brand-subtitle {
  color: #5e7688;
  font-size: 11px;
  letter-spacing: 0.08em;
}

.nav-right {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
}

.top-nav-menu {
  border-bottom: none !important;
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: transparent !important;
  height: 40px;
}

.top-nav-menu >>> .el-menu-item,
.top-nav-menu >>> .el-submenu__title {
  display: inline-flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  margin: 0 4px;
  border-radius: 0;
  border-bottom: none !important;
  padding: 0 12px !important;
  font-size: 13px;
  font-weight: 600;
  position: relative;
}

.top-nav-menu >>> .el-menu-item i,
.top-nav-menu >>> .el-submenu__title i {
  color: inherit;
  margin-right: 8px;
}

.top-nav-menu >>> .el-menu-item:hover,
.top-nav-menu >>> .el-submenu__title:hover {
  color: #1f87be !important;
  background: transparent !important;
}

.top-nav-menu >>> .el-menu-item.is-active,
.top-nav-menu >>> .el-submenu.is-active .el-submenu__title {
  color: #1f87be !important;
  background: transparent !important;
  box-shadow: inset 0 -2px 0 #1f87be;
}

.avatar-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e2eaf0;
}

.avatar-mark {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f5fafc;
  color: #1f87be;
  border: 1px solid #cfe2ec;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.user-name {
  color: #111827;
  font-size: 13px;
  font-weight: 700;
}

.user-role {
  margin-top: 2px;
  color: #5e7688;
  font-size: 11px;
}

@media (max-width: 1280px) {
  .navbar {
    flex-direction: column;
    align-items: stretch;
  }

  .nav-right {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .top-nav-menu {
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 14px 16px;
  }

  .brand-subtitle,
  .user-role {
    display: none;
  }

  .top-nav-menu >>> .el-menu-item,
  .top-nav-menu >>> .el-submenu__title {
    padding: 0 10px !important;
    font-size: 13px;
  }
}
</style>
